import React from 'react';
import { Box, List, ListIcon, ListItem, Text, VStack } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import { ReactComponent as Dot } from 'resources/images/dot.svg';
import { PasswordInput } from 'app/components/Core';
import { DeleteAccountForm } from '../types';
import { deleteAccountRulesList } from '../constants';

export const DeleteAccountPasswordStep = () => {
  const {
    formState: { errors },
    register,
    clearErrors,
  } = useFormContext<DeleteAccountForm>();

  return (
    <VStack>
      <Box>
        <Text fontSize="sm" pb={4} color="M.70">
          By deleting your account you will lose access to all you Songs,
          Releases and other assets on Session Studio.
        </Text>
        <List pb={4} pl={2}>
          {deleteAccountRulesList.map(
            (item: { label: string; id: string }, i) => (
              <ListItem
                key={item.id}
                display="flex"
                alignItems="flex-start"
                pb={6}
                pt={i === 0 ? 2 : 0}
                _last={{ pb: 0 }}
              >
                <ListIcon as={Dot} width={1} height={1} mt={2.5} />
                <Text fontSize="sm" color="M.70">
                  {item.label}
                </Text>
              </ListItem>
            )
          )}
        </List>
        <Text
          color="M.60"
          fontSize="xs"
          fontWeight={400}
          lineHeight="16px"
          pt={3}
          pb={5}
        >
          To continue, enter your password below
        </Text>
      </Box>
      <PasswordInput
        label="Password"
        isInvalid={Boolean(errors?.password)}
        errorMessage={errors?.password?.message}
        {...register('password', {
          onBlur: () => {
            if (errors.password?.type === 'manual') {
              clearErrors();
            }
          },
        })}
        data-testid="account-delete-password"
        errorMessageProps={{
          'data-testid': 'account-delete-password-error-text',
        }}
      />
    </VStack>
  );
};
